<template>
    <div class="index-promo-section" v-if="indexPromo != null && pageSetup != null">
        <div class="container">
            <div class="index-promo-section-container">
                <div class="project-adres" v-if="isMobileGlobal">
                    <div class="pin-marker">
                        <svgIcon name="marker-head" />
                    </div>
                    <p v-html="pageSetup.project_adres"></p>
                </div>
                <div class="promo-pic-desctop" v-if="!isMobileGlobal">
                    <img :src="indexPromo.index_promo_img" alt="">
                </div>
                <div class="promo-pic-mobile" :style="'background-image:url(' + indexPromo.index_promo_img_mobile + ')'" v-if="isMobileGlobal">
                    <div class="page-title-mobile">
                        <h1 v-html="indexPromo.main_title"></h1>
                    </div>
                </div>
                <div class="page-title" v-if="!isMobileGlobal">
                    <h1 v-html="indexPromo.main_title"></h1>
                </div>
                <div class="btns-left">
                    <a href="#menu-link-main" v-smooth-scroll="{offset: offset}" class="promo-link flats-btn"><span>{{pageSetup.book_btn}}</span></a>
                    <!-- <a href="#menu-link-main" v-smooth-scroll="{offset: offset}" class="promo-link flats-btn"><span>{{pageSetup.book_btn_taunhouse}}</span></a> -->
                    <a :href="pageSetup.btn_present_group.file" target="_blank" class="promo-link present-btn" v-if="pageSetup.btn_present_group.file != false"><span>{{pageSetup.btn_present_group.title}}</span></a>
                </div>
            </div>
        </div>
        <!-- <div class="promo-pic-desctop-mobile" v-if="isMobileGlobal">
            <img :src="indexPromo.index_promo_mobile" alt="">
        </div> -->
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    // import promoForm from '@/components/forms/form.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'index-promo-section',
        data () {
            return {
                offset: 0,
                isMobile: false,
            }
        },
        computed: mapGetters({
            pageSetup: 'loadPageSetUp',
            indexPromo: 'loadIndexPromo',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            svgIcon,
            // promoForm,
        },
        
        methods: {
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                    this.mobileOffset();
                }
            },
            mobileOffset() {
                this.offset = -55
            }
        },
        created() {
            this.isMobileCheck();
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/index-promo/index-promo.scss';
    @import '@/styles/components/index-promo/index-promo-respond.scss';
</style>